/** Enough rows to find the pattern in the file without flooding the line. */
const ROWS_LISTED = 5;

/** Whether `describeRows` leaves some of these rows out. */
export const cutsRows = (rows: readonly number[]): boolean =>
  rows.length > ROWS_LISTED;

/** "row 4", or every row: "rows 2, 3, 4, 5, 6, 7, 8". */
export const listAllRows = (rows: readonly number[]): string =>
  `${rows.length === 1 ? "row" : "rows"} ${rows.join(", ")}`;

/** "row 4", "rows 4, 9", or "rows 2, 3, 4, 5, 6 and 3 more". */
export const describeRows = (rows: readonly number[]): string => {
  const listed = rows.slice(0, ROWS_LISTED).join(", ");
  const unlisted = rows.length - ROWS_LISTED;
  const noun = rows.length === 1 ? "row" : "rows";

  return unlisted > 0
    ? `${noun} ${listed} and ${unlisted} more`
    : `${noun} ${listed}`;
};
